import React from 'react';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import { useShellContext } from 'hooks/useShellContext';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

import './QuizControl.scss';

const QUIZ_TYPES = {
  EXERCISE: 'EXERCISE'
};

const buttonClasses = 'hot-button hot-button--secondary hot-button--sm _text-2';

const QuizControl = ({
  quizType,
  currentTab,
  isMobile,
  className,
  onTabChange
}) => {
  const { isMembership } = useShellContext();

  const handlePreviousTab = () => {
    const tabIndex =
      quizType === QUIZ_TYPES.EXERCISE
        ? // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          currentTab - 2
        : currentTab - 1;

    onTabChange?.(tabIndex);
  };

  const handleNextTab = () => {
    const tabIndex =
      quizType === QUIZ_TYPES.EXERCISE
        ? // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          currentTab + 2
        : currentTab + 1;

    onTabChange?.(tabIndex);
  };

  const fixedBarClasses = classNames(
    {
      '_d-flex _position-fixed _w-full _border _border-top-0 _border-gray-200 _bg-white _p-4 quiz-control':
        isMobile
    },
    { 'quiz-control__is-membership': isMembership },
    className
  );
  const nextButtonClasses = classNames(buttonClasses, {
    'hot-button--block': isMobile
  });
  const previousButtonClasses = classNames(nextButtonClasses, '_mr-4');

  return (
    <div className={fixedBarClasses}>
      <button
        className={previousButtonClasses}
        disabled={currentTab === 0}
        onClick={handlePreviousTab}
      >
        <I18n label="general.previous" />
      </button>

      <button
        className={nextButtonClasses}
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        disabled={currentTab === 2}
        onClick={handleNextTab}
      >
        <I18n label="general.next" />
      </button>
    </div>
  );
};

QuizControl.propTypes = {
  quizType: PropTypes.string,
  currentTab: PropTypes.number,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  onTabChange: PropTypes.func
};

export default inject((store) => ({
  isMobile: store.UiStore.isMobile
}))(QuizControl);
